<template>
  <div class="carte needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="carte.title" text="carte.info" ></Info>
    <div class="title">
      <h3>{{$t('carte.title')}}</h3>
    </div>
    <div class="main-content">
      <chartist id="carte" ref="chart" :data="chartData" :options="chartOptions" type="Pie" :event-handlers="eventHandlers"></chartist>
      <div class="total-clients">{{this.totalClient | splitNumber}} <br> <span class="font-client">{{$t('carte.clients')}}</span></div>
    </div>
    <ul class="point-legends">
      <li>
        <div class="point point1"></div>
        <div>{{$t('carte.clientsWithCard')}}</div>
        <div style="font-weight:bold;">{{chartData.series[1] | splitNumber}} ({{percentage(1)}}%)</div>
      </li>
      <li>
        <div class="point point2"></div>
        <div>{{$t('carte.clientsWithoutCard')}}</div>
        <div style="font-weight:bold;">{{chartData.series[0] | splitNumber}} ({{percentage(0)}}%)</div>
      </li>
    </ul>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Carte',
    components: {
      Info
    },
    props: {
      result: Object, 
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      }, 
      nbOfColumns() {
        this.refresh()
      }
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          donut: true,
          donutWidth: 10,
          donutSolid: true,
          startAngle: 0,
          showLabel: false,
        },
        myHeight: 0,
        myWidth: 0, 
        eventHandlers: []
      }
    },
    computed: {
      chartData() {
        let loyalty = 0
        let noLoyalty = 0
        if (this.result && this.result.hits && this.result.aggregations && this.result.aggregations.loyalty) {
          let hits = this.totalClient
          loyalty = this.result.aggregations.loyalty.doc_count
          noLoyalty = hits - loyalty
        }
        return {series: [noLoyalty, loyalty]}
      }, 
      totalClient() {
        return (this.result && this.result.hits) ? this.result.hits.total : 0
      }
    },
    methods: {
      percentage(index) {
        return (Math.round(this.chartData.series[index] * 100 / (this.chartData.series[0] + this.chartData.series[1]) * 10) / 10).toLocaleString()
      },
      onFullScreen() {
        if(this.myHeight == 0) {
          this.myHeight = document.getElementById('carte').clientHeight - 4
          this.myWidth = document.getElementById('carte').clientWidth
        }
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          this.chartOptions.width = "40vw"
          this.chartOptions.height = "40vh"
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
        }
        this.$refs.chart.redraw()
      }, 
      refresh() {
        if (this.$refs.chart) {
          this.$refs.chart.redraw()
        }
      }
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/carte.sass"
</style>
